import { render } from "./PermissionButtons.vue?vue&type=template&id=85ddfb9e"
import script from "./PermissionButtons.vue?vue&type=script&lang=js"
export * from "./PermissionButtons.vue?vue&type=script&lang=js"

import "./PermissionButtons.vue?vue&type=style&index=0&id=85ddfb9e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__